import { ordinal } from '@/lib/kudos';

export interface Stat { label: string; value: string }

/** A row of figures with small labels underneath: points, accuracy and so on. Two or four sit in pairs, others in threes. */
export function StatGrid({ items, className = '' }: { items: Stat[]; className?: string }) {
  if (!items.length) return null;
  return (
    <dl data-part="stats" className={`grid gap-2 ${items.length <= 2 || items.length === 4 ? 'grid-cols-2' : 'grid-cols-3'} ${className}`}>
      {items.map((s) => (
        <div key={s.label} data-part="stat" className="flex flex-col-reverse justify-end rounded-tile bg-surface-2 px-3 py-2.5">
          <dt className="text-xs font-semibold text-ink-3">{s.label}</dt>
          <dd className="numeral text-[1.6rem] leading-tight text-ink">{s.value}</dd>
        </div>
      ))}
    </dl>
  );
}

/** "57th of 212": the place in big numerals, the size of the room beside it, read out as one phrase. */
export function PlaceLine({ rank, players, className = '' }: { rank: number; players: number; className?: string }) {
  const digits = rank.toLocaleString('en-GB');
  const suffix = ordinal(rank).replace(/^\d+/, '');
  const of = `of ${Math.max(players, rank).toLocaleString('en-GB')}`;
  return (
    <p data-part="place" className={`flex items-end gap-2 ${className}`}>
      <span className="sr-only">{`${digits}${suffix} ${of}`}</span>
      <span aria-hidden="true" data-part="place-figure" className="numeral text-6xl leading-[0.85] text-ink">{digits}<span className="align-top text-[0.4em] leading-none">{suffix}</span></span>
      <span aria-hidden="true" data-part="place-of" className="pb-1 font-semibold text-ink-2">{of}</span>
    </p>
  );
}
